export const hotNftsData = [
  {
    category: "All",
  },
  {
    category: "Music",
  },
  {
    category: "Art",
  },
  {
    category: "Sports",
  },
  {
    category: "Virtual",
  },
  {
    category: "Videoes",
  },
];
